<div #slideMenuContainer id="{{widgetId}}-toolbar-settings" aria-label="slide menu" aria-hidden="false">
  <div class="adx-toolbar-settings-inner-wrapper">
    <mat-toolbar class="primary">
      {{ "MAP.SETTINGS" | translate }}
      <span class="adx-toolbar-spacer"></span>
      <button mat-icon-button class="toolbar-settings-close-button" aria-label="Close Button" (click)="closeSlideMenu()">
        <fa-icon [icon]="'xmark'"></fa-icon>
      </button>
    </mat-toolbar>
    <div class="adx-toolbar-settings-content">
      <h3 class="adx-heading-no-margin">{{ 'MAP.MAP_SETTINGS' | translate | uppercase }}</h3>
      @if (widgetPermissions?.aisTargetsDataEnabled && initialMapSettings.aisTargetsActive) {
        <div class="adx-toggle-alignment-container">
          <div class="adx-toggle-label-container">
            <div class="adx-svg-toolbar-settings-icon-container">
              <span class="adx-svg-toolbar-settings-icon" [innerHTML]="radarTargetSvg(this.sanitizer)"></span>
            </div>
            <span >
              {{ 'MAP.VESSELS' | translate }}
              ({{ 'AIS-' }}{{ 'MAP.SIGNAL' | translate }})
              {{ 'MAP.SHOW' | translate | lowercase }}
            </span>
          </div>
          <mat-slide-toggle
            class="toggle-float-position primary"
            [checked]="settingDisplayChanges.AIS.aISTargetsVisible"
            (change)="toggleSwitcherEvent($event, settingDisplayChanges.AIS.action)"
            >
          </mat-slide-toggle>
        </div>
      }
      @if (widgetPermissions?.maritimeTargetsDataEnabled && initialMapSettings.maritimeTargetsActive) {
        <div class="adx-toggle-alignment-container">
          <div class="adx-toggle-label-container">
            <div class="adx-svg-toolbar-settings-icon-container">
              <span class="adx-svg-toolbar-settings-icon" [innerHTML]="maritimeTargetsTLLAIS(this.sanitizer)"></span>
              <span class="adx-svg-toolbar-settings-icon" [innerHTML]="maritimeTargetsTTD(this.sanitizer)"></span>
            </div>
            <span class=" slide-toggle-label-spacer">
              {{ 'MAP.MARITIME_TARGETS' | translate | titlecase }}
              {{ 'MAP.SHOW' | translate | lowercase }}
            </span>
          </div>
          <mat-slide-toggle
            class="toggle-float-position primary"
            [checked]="settingDisplayChanges.MaritimeTargets.maritimeTargetsVisible"
            (change)="toggleSwitcherEvent($event, settingDisplayChanges.MaritimeTargets.action)"
            >
          </mat-slide-toggle>
        </div>
      }
      @if (widgetPermissions?.radarTargetDataEnabled && initialMapSettings.radarTargetActive) {
        <div class="adx-toggle-alignment-container">
          <div class="adx-toggle-label-container">
            <fa-icon [icon]="'square'" [size]="'lg'" class="adx-icon-spacer adx-radar-target-icon-color"></fa-icon>
            <span class=" slide-toggle-label-spacer">
              {{ 'MAP.RADAR_TARGETS' | translate }}
              {{ 'MAP.SHOW' | translate | lowercase }}
            </span>
          </div>
          <mat-slide-toggle
            class="toggle-float-position primary"
            [checked]="settingDisplayChanges.RadarTarget.radarTargetVisible"
            (change)="toggleSwitcherEvent($event, settingDisplayChanges.RadarTarget.action)"
            >
          </mat-slide-toggle>
        </div>
      }
      @if (widgetPermissions?.fusionMaritimeTargetDataEnabled && initialMapSettings.fusionMaritimeTargetActive) {
        <div class="adx-toggle-alignment-container">
          <div class="adx-toggle-label-container">
            <fa-icon [icon]="['far', 'circle-dot']" [size]="'lg'" class="adx-icon-spacer adx-fusion-maritime-target-icon-color"></fa-icon>
            <span class=" slide-toggle-label-spacer">
              {{ 'MAP.FUSION_MARITIME_TARGETS' | translate }}
              {{ 'MAP.SHOW' | translate | lowercase }}
            </span>
          </div>
          <mat-slide-toggle
            class="toggle-float-position primary"
            [checked]="settingDisplayChanges.FusionMaritimeTarget.fusionMaritimeTargetVisible"
            (change)="toggleSwitcherEvent($event, settingDisplayChanges.FusionMaritimeTarget.action)"
            >
          </mat-slide-toggle>
        </div>
      }
      <ng-container>
        <div class="adx-toggle-alignment-container">
          <div class="adx-toggle-label-container">
            <fa-icon [icon]="['far' , 'message']" [size]="'lg'" class="adx-icon-spacer"></fa-icon>
            <span class=" slide-toggle-label-spacer">
              {{ 'MAP.PERMANENT_ICON_DATA_DISPLAY' | translate }}
            </span>
          </div>
          <mat-slide-toggle
            class="toggle-float-position primary"
            [checked]="settingDisplayChanges.global.showPermanentTooltip"
            (change)="toggleSwitcherEvent($event, 'mapShowPermanentTooltip')"
            >
          </mat-slide-toggle>
        </div>
      </ng-container>
    </div>
  </div>
</div>
